import React from 'react';

import { Container } from './styles';

export default function Footer({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>;
}
